<template>
    <div class="card h-o-card-auth">
        <div v-if="!hideLogo" class="card-header">
            <div class="logo-wrapper">
                <a :href="logoLink">
                    <img class="d-block mx-auto" src="/images/auth/logo-transparent.png" srcset="/images/auth/logo-transparent@2x.png 2x" alt="Hostoo">
                </a>
            </div>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            logoLink: {
                type: String,
                default: '/'
            },
            hideLogo: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="stylus">
    .h-o-card-auth
        border 0
        border-radius 0
        margin 1rem 0
        background none

        @media (min-width 576px)
            margin 3rem 0

        > .card-header
            padding 0
            border 0
            border-radius 0
            overflow hidden

            &:before
                content ""
                display block
                height 3rem
                border-radius 1rem 1rem 0 0
                background-color white

        .logo-wrapper
            position relative
            display flex

            &:before, &:after
                content ""
                background-color white
                flex-grow 1

        > .card-body
            border-radius 0 0 1rem 1rem
            background-color white

            &:first-child
                border-top-left-radius 1rem
                border-top-right-radius 1rem

            @media (min-width 576px)
                padding 1.5rem 3rem 4.5rem 3rem
                border-bottom-right-radius 10rem

        .form-group
            background-color #F2F2F2

            .form-label
                margin 0
                padding .75rem .875rem 0
                font-weight 600
                line-height 1
                color lighten($primary, 12%)

            .form-control
                border-radius 0
                border-width 0 0 1px 0
                border-color $gray-400
                padding 0 .875rem .25rem .875rem
                height auto
                font-size 1.25rem
                line-height 1.25
                background-color transparent
                box-shadow none
                outline 0
                transition border-color 0.15s ease-in-out

                &:focus
                    border-color $primary

                &:-webkit-autofill,
                &:-webkit-autofill:hover,
                &:-webkit-autofill:focus textarea:-webkit-autofill {
                    -webkit-box-shadow 0 0 0px 1000px #F2F2F2 inset !important
                }


            .invalid-feedback
                margin-top 0
                padding-top 0.25rem
                background-color white
</style>